import { z } from 'zod/v4';

export const unemployedFormSchema = z.object({
  kind: z.literal('unemployed'),
});

type UnemployedFormValues = z.infer<typeof unemployedFormSchema>;

export const defaultUnemployedFormValues: UnemployedFormValues = {
  kind: 'unemployed',
};

// There is no need for a component for the unemployed form, because it has no additional fields
